module.exports = __webpack_public_path__ + "static/media/hrAviationNew.0feb6626.png";